(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brisro-global-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-brisro-global-header-root]').forEach(function(root){
    if(root.dataset.ready==='1')return;
    root.dataset.ready='1';

    var header=root.querySelector('[data-brisro-header]');
    var menu=root.querySelector('[data-brisro-mobile-menu]');
    var toggle=root.querySelector('[data-brisro-menu-toggle]');
    var close=root.querySelector('[data-brisro-menu-close]');
    var hideOnScroll=root.getAttribute('data-hide-on-scroll')==='true';

    if(!header||!menu||!toggle||!close)return;

    var lastScroll=window.pageYOffset||document.documentElement.scrollTop||0;
    var ticking=false;
    var threshold=12;

    function openMenu(){
      menu.classList.add('is-open');
      document.body.classList.add('brisro-global-menu-open');
      menu.setAttribute('aria-hidden','false');
      toggle.setAttribute('aria-expanded','true');
      header.classList.remove('is-hidden');
    }

    function closeMenu(){
      menu.classList.remove('is-open');
      document.body.classList.remove('brisro-global-menu-open');
      menu.setAttribute('aria-hidden','true');
      toggle.setAttribute('aria-expanded','false');
    }

    toggle.addEventListener('click',function(){
      menu.classList.contains('is-open')?closeMenu():openMenu();
    });

    close.addEventListener('click',closeMenu);

    menu.addEventListener('click',function(event){
      if(event.target===menu)closeMenu();
    });

    menu.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click',closeMenu);
    });

    document.addEventListener('keydown',function(event){
      if(event.key==='Escape')closeMenu();
    });

    if(hideOnScroll){
      window.addEventListener('scroll',function(){
        if(ticking)return;

        window.requestAnimationFrame(function(){
          var scrollTop=window.pageYOffset||document.documentElement.scrollTop||0;
          var diff=scrollTop-lastScroll;

          if(menu.classList.contains('is-open')||scrollTop<=10){
            header.classList.remove('is-hidden');
          }else if(diff>threshold){
            header.classList.add('is-hidden');
          }else if(diff<-threshold){
            header.classList.remove('is-hidden');
          }

          lastScroll=scrollTop;
          ticking=false;
        });

        ticking=true;
      },{passive:true});
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brisro-vehicle-signage-plan"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-vsp-root]').forEach(function (root) {
    if (root.getAttribute('data-ready') === '1') return;
    root.setAttribute('data-ready', '1');

    var form = root.querySelector('form');
    var nativeSuccess = root.querySelector('[data-success-native]');
    var fallbackSuccess = root.querySelector('[data-success-fallback]');
    var successParams = new URLSearchParams(window.location.search);
    var redirectedSuccess = successParams.get('vsp_success') === '1';
    var success = nativeSuccess || (redirectedSuccess ? fallbackSuccess : null);

    if (redirectedSuccess && fallbackSuccess) {
      fallbackSuccess.hidden = false;
      if (form) form.hidden = true;
    }

    var summary = root.querySelector('[data-summary]');
    var hiddenVehicle = root.querySelector('[data-hidden-vehicle]');
    var hiddenGoal = root.querySelector('[data-hidden-goal]');
    var hiddenCount = root.querySelector('[data-hidden-count]');
    var postcode = form ? form.querySelector('[name="contact[postcode]"]') : null;
    var sticky = root.querySelector('[data-sticky]');
    var storageKey = 'brisroSignagePlanPage';

    function pageStep(number) {
      return root.querySelector('[data-page-step="' + number + '"]');
    }

    function scrollToStep(number) {
      var target = pageStep(number);
      if (!target) return;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      var heading = target.querySelector('h2');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        window.setTimeout(function () {
          try { heading.focus({ preventScroll: true }); } catch (e) {}
        }, reduced ? 0 : 350);
      }
    }

    root.querySelectorAll('[data-scroll-form]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        if (el.tagName && el.tagName.toLowerCase() === 'a') event.preventDefault();
        scrollToStep(1);
      });
    });

    function selectOne(selector, current) {
      root.querySelectorAll(selector).forEach(function (button) {
        button.classList.toggle('is-selected', button === current);
      });
    }

    function refreshButtons() {
      var step1 = root.querySelector('[data-page-next="2"]');
      var step2 = root.querySelector('[data-page-next="3"]');
      var step3 = root.querySelector('[data-page-next="4"]');

      if (step1) step1.disabled = !(hiddenVehicle && hiddenVehicle.value);
      if (step2) step2.disabled = !(hiddenGoal && hiddenGoal.value);
      if (step3) step3.disabled = !(hiddenCount && hiddenCount.value && postcode && postcode.value.trim());
    }

    root.querySelectorAll('[data-builder-vehicle]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (hiddenVehicle) hiddenVehicle.value = button.getAttribute('data-builder-vehicle') || '';
        selectOne('[data-builder-vehicle]', button);
        saveState();
        refreshButtons();
      });
    });

    root.querySelectorAll('[data-builder-goal]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (hiddenGoal) hiddenGoal.value = button.getAttribute('data-builder-goal') || '';
        selectOne('[data-builder-goal]', button);
        saveState();
        refreshButtons();
      });
    });

    root.querySelectorAll('[data-builder-count]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (hiddenCount) hiddenCount.value = button.getAttribute('data-builder-count') || '';
        selectOne('[data-builder-count]', button);
        saveState();
        refreshButtons();
      });
    });

    root.querySelectorAll('[data-page-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        scrollToStep(Number(button.getAttribute('data-page-next')));
      });
    });

    root.querySelectorAll('[data-page-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        scrollToStep(Number(button.getAttribute('data-page-back')));
      });
    });

    if (postcode) {
      postcode.addEventListener('input', function () {
        refreshButtons();
        saveState();
      });
    }

    function state() {
      var data = {
        vehicle: hiddenVehicle ? hiddenVehicle.value : '',
        goal: hiddenGoal ? hiddenGoal.value : '',
        count: hiddenCount ? hiddenCount.value : ''
      };

      if (form) {
        form.querySelectorAll('[data-field]').forEach(function (field) {
          data[field.getAttribute('data-field')] = field.value || '';
        });
      }

      return data;
    }

    function saveState() {
      if (success) return;
      try { sessionStorage.setItem(storageKey, JSON.stringify(state())); } catch (e) {}
    }

    function restoreState() {
      if (!form || success) return;
      var data = null;

      try { data = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (e) {}
      if (!data) return;

      if (hiddenVehicle && data.vehicle) hiddenVehicle.value = data.vehicle;
      if (hiddenGoal && data.goal) hiddenGoal.value = data.goal;
      if (hiddenCount && data.count) hiddenCount.value = data.count;

      root.querySelectorAll('[data-builder-vehicle]').forEach(function (button) {
        button.classList.toggle('is-selected', button.getAttribute('data-builder-vehicle') === data.vehicle);
      });

      root.querySelectorAll('[data-builder-goal]').forEach(function (button) {
        button.classList.toggle('is-selected', button.getAttribute('data-builder-goal') === data.goal);
      });

      root.querySelectorAll('[data-builder-count]').forEach(function (button) {
        button.classList.toggle('is-selected', button.getAttribute('data-builder-count') === data.count);
      });

      form.querySelectorAll('[data-field]').forEach(function (field) {
        var key = field.getAttribute('data-field');
        if (!field.value && typeof data[key] === 'string') field.value = data[key];
      });

      refreshButtons();
    }

    function captureUTM() {
      if (!form) return;

      var params = new URLSearchParams(window.location.search);

      form.querySelectorAll('[data-utm]').forEach(function (input) {
        var key = input.getAttribute('data-utm');
        var current = params.get(key);

        if (current) {
          input.value = current;
          try { sessionStorage.setItem('brisro-' + key, current); } catch (e) {}
        } else {
          try { input.value = sessionStorage.getItem('brisro-' + key) || ''; } catch (e) {}
        }
      });
    }

    if (form) {
      form.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('input', saveState);
        input.addEventListener('change', saveState);
      });

      form.addEventListener('submit', function (event) {
        if (!(hiddenVehicle && hiddenVehicle.value)) {
          event.preventDefault();
          scrollToStep(1);
          return;
        }

        if (!(hiddenGoal && hiddenGoal.value)) {
          event.preventDefault();
          scrollToStep(2);
          return;
        }

        if (!(hiddenCount && hiddenCount.value && postcode && postcode.value.trim())) {
          event.preventDefault();
          scrollToStep(3);
          return;
        }

        if (summary) {
          var business = form.querySelector('[name="contact[business_name]"]');

          summary.value = [
            'FREE VEHICLE SIGNAGE PLAN',
            '',
            'Vehicle type: ' + hiddenVehicle.value,
            'Desired result: ' + hiddenGoal.value,
            'Vehicle count: ' + hiddenCount.value,
            'Postcode: ' + postcode.value.trim(),
            'Business: ' + (business && business.value.trim() ? business.value.trim() : 'Not supplied')
          ].join('\n');
        }

        saveState();
      });
    }

    if (!success) {
      restoreState();
      captureUTM();
      refreshButtons();
    }

    if (success) {
      try { sessionStorage.removeItem(storageKey); } catch (e) {}

      var successEventKey = 'brisroSignagePlanSuccessEventFired';
      var shouldFireSuccessEvent = true;

      try {
        shouldFireSuccessEvent = sessionStorage.getItem(successEventKey) !== '1';
        if (shouldFireSuccessEvent) sessionStorage.setItem(successEventKey, '1');
      } catch (e) {}

      if (shouldFireSuccessEvent) {
        window.dispatchEvent(new CustomEvent('brisro:vehicle-signage-plan-submitted'));

        if (root.getAttribute('data-fire-meta-lead') === 'true' && typeof window.fbq === 'function') {
          window.fbq('track', 'Lead');
        }
      }

      if (sticky) sticky.classList.add('hidden');

      window.requestAnimationFrame(function () {
        if (typeof success.focus === 'function') {
          try { success.focus({ preventScroll: true }); } catch (e) {}
        }
      });
    }

    var conversionArea = root.querySelector('.vsp-form-section--journey');
    if (sticky && conversionArea && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('hidden', entries.some(function (entry) {
          return entry.isIntersecting;
        }));
      }, { threshold: 0.05 });

      observer.observe(conversionArea);
    }

    if (sticky && window.visualViewport) {
      var baseHeight = window.visualViewport.height;
      window.visualViewport.addEventListener('resize', function () {
        sticky.classList.toggle('hidden', window.visualViewport.height < baseHeight * 0.72);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brisro-vehicle-signage-version-b"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-brisro-vb-root]').forEach(function(root){
  if(root.dataset.ready==='1')return;
  root.dataset.ready='1';

  var form=root.querySelector('form');
  var formSection=root.querySelector('[data-vb-form-section]');
  var formContent=root.querySelector('[data-vb-form-content]');
  var fallbackSuccess=root.querySelector('[data-vb-success-fallback]');
  var nativeSuccess=root.querySelector('[data-vb-native-success]');
  var nativeErrors=root.querySelector('[data-vb-native-errors]');
  var sticky=root.querySelector('[data-vb-sticky]');
  var finalBefore=root.querySelector('[data-vb-final-before]');
  var finalAfter=root.querySelector('[data-vb-final-after]');
  var stickyBefore=root.querySelector('[data-vb-sticky-before]');
  var stickyAfter=root.querySelector('[data-vb-sticky-after]');
  var params=new URLSearchParams(window.location.search);
  var redirectedSuccess=params.get('vsp_success')==='1';
  var success=nativeSuccess||(redirectedSuccess?fallbackSuccess:null);
  var submittedStateKey='brisro_signage_lead_submitted';
  var sessionSubmitted=false;

  try{
    sessionSubmitted=sessionStorage.getItem(submittedStateKey)==='true';
  }catch(e){}

  function applySubmittedCtaState(isSubmitted){
    if(finalBefore)finalBefore.hidden=isSubmitted;
    if(finalAfter)finalAfter.hidden=!isSubmitted;
    if(stickyBefore)stickyBefore.hidden=isSubmitted;
    if(stickyAfter)stickyAfter.hidden=!isSubmitted;
  }

  applySubmittedCtaState(sessionSubmitted||Boolean(success));

  function emit(name,detail){
    detail=detail||{};
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(key){
      if(params.get(key)&&typeof detail[key]==='undefined')detail[key]=params.get(key);
    });

    window.dispatchEvent(new CustomEvent('brisro:'+name,{detail:detail}));

    if(Array.isArray(window.dataLayer)){
      window.dataLayer.push(Object.assign({event:name},detail));
    }
  }

  function scrollForm(){
    if(!formSection)return;
    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    formSection.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});
  }

  var mobileAutoAdvanceQuery=window.matchMedia?window.matchMedia('(max-width: 767px)'):null;
  var reducedMotionQuery=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
  var goalSection=root.querySelector('[data-vb-goal-section]');
  var contactSection=root.querySelector('[data-vb-contact-section]');

  function isMobileAutoAdvance(){
    return Boolean(mobileAutoAdvanceQuery&&mobileAutoAdvanceQuery.matches);
  }

  function isTargetComfortablyVisible(target){
    if(!target)return true;

    var rect=target.getBoundingClientRect();
    var viewportHeight=window.innerHeight||document.documentElement.clientHeight||0;
    var headerClearance=88;

    /*
      If the start of the next section is already comfortably visible,
      don't move the page underneath the visitor.
    */
    return rect.top>=headerClearance&&rect.top<=viewportHeight*.68;
  }

  function autoAdvanceTo(target){
    if(!target||!isMobileAutoAdvance()||isTargetComfortablyVisible(target))return;

    var reduced=Boolean(reducedMotionQuery&&reducedMotionQuery.matches);
    var delay=reduced?0:140;

    window.setTimeout(function(){
      /*
        Re-check after the short confirmation delay because the visitor
        may have manually moved the page in the meantime.
      */
      if(!isMobileAutoAdvance()||isTargetComfortablyVisible(target))return;

      target.scrollIntoView({
        behavior:reduced?'auto':'smooth',
        block:'start'
      });
    },delay);
  }

  root.querySelectorAll('[data-vb-scroll-form]').forEach(function(el){
    el.addEventListener('click',function(e){
      if(el.tagName&&el.tagName.toLowerCase()==='a')e.preventDefault();
      emit('hero_cta_click');
      scrollForm();
    });
  });

  emit('landing_view');

  if(form){
    var started=false;

    function start(){
      if(started)return;
      started=true;
      emit('form_start');
    }

    form.addEventListener('input',start,{once:true});
    form.addEventListener('change',start,{once:true});

    var vehicleSelectionMade=Boolean(form.querySelector('[data-vb-vehicle]:checked'));
    var goalSelectionMade=Boolean(form.querySelector('[data-vb-goal]:checked'));

    form.querySelectorAll('[data-vb-vehicle]').forEach(function(input){
      input.addEventListener('change',function(){
        var editingExistingAnswer=vehicleSelectionMade;
        vehicleSelectionMade=true;

        emit('vehicle_selected',{vehicle_type:input.value});

        /*
          Mobile-only guided progression.
          Do not auto-advance when the visitor is changing an earlier answer.
        */
        if(input.checked&&!input.disabled&&!editingExistingAnswer){
          window.requestAnimationFrame(function(){
            autoAdvanceTo(goalSection);
          });
        }
      });
    });

    form.querySelectorAll('[data-vb-goal]').forEach(function(input){
      input.addEventListener('change',function(){
        var editingExistingAnswer=goalSelectionMade;
        goalSelectionMade=true;

        emit('signage_goal_selected',{signage_goal:input.value});

        /*
          Move to contact details only on the visitor's first valid goal choice.
          Focus remains where the visitor put it; this only moves the viewport.
        */
        if(input.checked&&!input.disabled&&!editingExistingAnswer){
          window.requestAnimationFrame(function(){
            autoAdvanceTo(contactSection);
          });
        }
      });
    });

    form.querySelectorAll('[data-vb-utm]').forEach(function(input){
      var key=input.getAttribute('data-vb-utm');
      var value=params.get(key);

      if(value){
        input.value=value;
        try{sessionStorage.setItem('brisro-'+key,value)}catch(e){}
      }else{
        try{input.value=sessionStorage.getItem('brisro-'+key)||''}catch(e){}
      }
    });

    form.addEventListener('submit',function(){
      emit('form_submit_attempt');
    });
  }

  root.querySelectorAll('[data-vb-prefill-goal]').forEach(function(button){
    button.addEventListener('click',function(){
      var goal=button.getAttribute('data-vb-prefill-goal');
      var matching=Array.prototype.slice.call(root.querySelectorAll('[data-vb-goal]')).find(function(input){
        return input.value===goal;
      });

      if(matching){
        matching.checked=true;
        matching.dispatchEvent(new Event('change',{bubbles:true}));
      }

      scrollForm();
    });
  });

  if((redirectedSuccess||sessionSubmitted)&&fallbackSuccess&&!nativeSuccess){
    fallbackSuccess.hidden=false;
    if(formContent)formContent.hidden=true;
  }

  if(success){
    try{
      sessionStorage.setItem(submittedStateKey,'true');
      sessionSubmitted=true;
    }catch(e){}

    applySubmittedCtaState(true);

    /*
      Remove the one-time success query marker after it has been consumed.
      The sessionStorage flag preserves the state for reloads in this session.
    */
    if(redirectedSuccess&&window.history&&window.history.replaceState){
      try{
        var cleanUrl=new URL(window.location.href);
        cleanUrl.searchParams.delete('vsp_success');
        window.history.replaceState(
          {},
          document.title,
          cleanUrl.pathname+
          (cleanUrl.searchParams.toString()?'?'+cleanUrl.searchParams.toString():'')+
          cleanUrl.hash
        );
      }catch(e){}
    }

    var fired=true;
    try{
      fired=sessionStorage.getItem('brisroVBLeadSuccess')==='1';
      if(!fired)sessionStorage.setItem('brisroVBLeadSuccess','1');
    }catch(e){fired=false}

    if(!fired){
      emit('lead_success');
      /* Deliberately no direct Meta fbq Lead call here. */
    }

    requestAnimationFrame(function(){
      try{success.focus({preventScroll:true})}catch(e){}
    });
  }else if(nativeErrors){
    emit('lead_error');
  }

  if(sticky&&formSection&&'IntersectionObserver'in window){
    new IntersectionObserver(function(entries){
      sticky.hidden=entries.some(function(entry){return entry.isIntersecting});
    },{threshold:.12}).observe(formSection);
  }

  if(sticky&&window.visualViewport){
    var base=window.visualViewport.height;
    window.visualViewport.addEventListener('resize',function(){
      if(window.visualViewport.height<base*.72)sticky.hidden=true;
    });
  }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
